import React from 'react';
import { SearchCard } from '../types';
import { BaseFeaturedSearchCard } from '../Base';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import {
  Price,
  GrayUIText,
  Title,
  BottomContent,
  BlackUIText,
  UnitPriceText,
} from '../Base/styles';
import {
  BoxConditionIcon,
  CartIcon,
  MapMarkerIcon,
  TruckIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  width: 149px;
  justify-content: space-between;
`;

const StyledPrice = styled(Price)`
  ${theme.typography.headings[6]['sm-lg']};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[1].rem};
  grid-template-rows: minmax(136px, 1fr) repeat(auto-fill, 169px);
`;

export const WineBuyNowFeaturedSearchCard: React.FC<
  SearchCard<'WineBuyNow'>
> = ({ title, condition, location, isDelivery, data, type, ...props }) => {
  return (
    <BaseFeaturedSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <Pill
          backgroundColor={theme.colors.tints.systemBlue[6]}
          icon={CartIcon}
        >
          Buy Now
        </Pill>
        <Container>
          <div>
            <StyledPrice>{data.secondaryPrice.price}</StyledPrice>
            <BlackUIText>
              <UnitPriceText>
                {' '}
                {data.perBottlePrice} Per {data.unitPricing.unitName}
              </UnitPriceText>
            </BlackUIText>
          </div>
          <BottomContent>
            <GrayUIText>
              <BoxConditionIcon
                width={16}
                fill={theme.colors.neutrals.solidGrays[3]}
              />
              {condition}
            </GrayUIText>
            {(condition as string).length < 13 && (
              <GrayUIText>
                {isDelivery ? (
                  <>
                    <TruckIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    Delivery
                  </>
                ) : (
                  <>
                    <MapMarkerIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    {location}
                  </>
                )}
              </GrayUIText>
            )}
          </BottomContent>
        </Container>
      </Content>
    </BaseFeaturedSearchCard>
  );
};
